const PENDING_AUTH_FLOW_KEY = 'blms-pending-auth-flow';
const PENDING_AUTH_FLOW_TTL_MS = 5 * 60 * 1000;

function canUseStorage(): boolean {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
}

function readPendingAuthFlowStartedAt(): number | null {
  if (!canUseStorage()) {
    return null;
  }

  try {
    const rawValue = window.localStorage.getItem(PENDING_AUTH_FLOW_KEY);
    if (!rawValue) {
      return null;
    }

    const startedAt = Number(rawValue);
    if (!Number.isFinite(startedAt)) {
      window.localStorage.removeItem(PENDING_AUTH_FLOW_KEY);
      return null;
    }

    return startedAt;
  } catch {
    return null;
  }
}

export function markPendingAuthFlow(): void {
  if (!canUseStorage()) {
    return;
  }

  try {
    window.localStorage.setItem(PENDING_AUTH_FLOW_KEY, String(Date.now()));
  } catch {
    // Ignore storage failures in locked-down browsers.
  }
}

export function clearPendingAuthFlow(): void {
  if (!canUseStorage()) {
    return;
  }

  try {
    window.localStorage.removeItem(PENDING_AUTH_FLOW_KEY);
  } catch {
    // Ignore storage failures in locked-down browsers.
  }
}

export function hasPendingAuthFlow(): boolean {
  const startedAt = readPendingAuthFlowStartedAt();
  if (startedAt === null) {
    return false;
  }

  try {
    const isFresh = Date.now() - startedAt <= PENDING_AUTH_FLOW_TTL_MS;
    if (!isFresh) {
      window.localStorage.removeItem(PENDING_AUTH_FLOW_KEY);
    }

    return isFresh;
  } catch {
    return false;
  }
}
